<!-- Geometry matches package `skelPackage` (desktop/tablet) and mobile 390pt Package body. -->
<div class="package-selection-skeleton" aria-hidden="true">
  <app-skeleton-block class="package-selection-skeleton__title" width="330" height="30" />
  <app-skeleton-block
    class="package-selection-skeleton__required"
    width="168"
    height="11"
    tone="secondary"
  />

  <!-- Desktop / tablet: four horizontal option rows. -->
  <div class="package-selection-skeleton__wide">
    @for (placeholder of cardPlaceholders; track placeholder) {
      <div class="package-selection-skeleton__card">
        <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
        <div class="package-selection-skeleton__card-copy">
          <app-skeleton-block width="268" height="18" />
          <app-skeleton-block width="176" height="11" tone="secondary" />
        </div>
        <div class="package-selection-skeleton__card-aside">
          <app-skeleton-block width="128" height="11" tone="secondary" />
          <app-skeleton-block width="196" height="11" tone="secondary" />
        </div>
        <app-skeleton-block width="86" height="62" radius="shell" tone="emphasis" />
      </div>
    }

    <div class="package-selection-skeleton__tracking">
      <app-skeleton-block width="232" height="22" />
      <app-skeleton-block width="340" height="12" tone="secondary" />
      <app-skeleton-block
        class="package-selection-skeleton__tracking-field"
        width="350"
        height="54"
        radius="card"
      />
    </div>

    <div class="package-selection-skeleton__divider"></div>

    <div class="package-selection-skeleton__actions">
      <app-skeleton-block width="86" height="52" radius="card" tone="secondary" />
      <app-skeleton-block width="186" height="52" radius="card" />
    </div>
  </div>

  <!-- Mobile: single expanded package card (prototype). -->
  <div class="package-selection-skeleton__mobile">
    <div class="package-selection-skeleton__mobile-card">
      <div class="package-selection-skeleton__mobile-radio-row">
        <app-skeleton-block width="24" height="24" radius="circle" [animated]="false" />
        <app-skeleton-block width="196" height="20" />
      </div>
      <app-skeleton-block
        class="package-selection-skeleton__mobile-subtitle"
        width="156"
        height="12"
        tone="secondary"
      />
      <div class="package-selection-skeleton__mobile-measure">
        <app-skeleton-block width="186" height="13" tone="secondary" />
        <app-skeleton-block width="86" height="62" radius="shell" tone="emphasis" />
      </div>
      <div class="package-selection-skeleton__mobile-grid">
        <app-skeleton-block height="58" radius="card" />
        <app-skeleton-block height="58" radius="card" />
      </div>
      <app-skeleton-block width="216" height="20" />
      <div class="package-selection-skeleton__mobile-unit">
        <app-skeleton-block width="148" height="13" tone="secondary" />
        <app-skeleton-block width="142" height="40" radius="circle" tone="emphasis" />
      </div>
      <div class="package-selection-skeleton__mobile-helpers">
        @for (width of helperLineWidths; track width) {
          <app-skeleton-block [width]="width" height="12" tone="secondary" />
        }
      </div>
      <div class="package-selection-skeleton__mobile-nest">
        <div class="package-selection-skeleton__mobile-nest-header">
          <app-skeleton-block width="108" height="19" />
          <div class="package-selection-skeleton__mobile-nest-actions">
            <app-skeleton-block width="62" height="13" tone="secondary" />
            <app-skeleton-block width="62" height="13" tone="secondary" />
          </div>
        </div>
        <app-skeleton-block height="58" radius="card" />
        <app-skeleton-block height="58" radius="card" />
        <div class="package-selection-skeleton__mobile-dim-meta">
          <app-skeleton-block width="102" height="17" />
          <app-skeleton-block width="58" height="30" radius="shell" />
          <app-skeleton-block width="20" height="20" radius="circle" [animated]="false" />
        </div>
        <app-skeleton-block height="58" radius="card" />
        <app-skeleton-block height="58" radius="card" />
      </div>
    </div>
  </div>
</div>
